import { DataCollection } from "@dhx/ts-data";
import { DataStore, Store } from "@xbs/muon";

export { Store };

export function initMathStore(sheets: DataCollection): DataStore {
	const store = new DataStore({strict: false});
	sheets.forEach(i => store.addPage(i.value));
	return store;
}
